document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('[data-wishlist-popup-trigger]');
  const modalBg = document.querySelector('.swym-custom-collections-modal-background--login');
  const closeBtn = document.querySelector('[data-wishlist-popup-close]');

  if (!modalBg || !triggers.length) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      modalBg.classList.add('open');
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modalBg.classList.remove('open');
    });
  }
});
